import { render, staticRenderFns } from "./ViewNews.vue?vue&type=template&id=dd7cac1a"
import script from "./ViewNews.vue?vue&type=script&lang=js"
export * from "./ViewNews.vue?vue&type=script&lang=js"
import style0 from "./ViewNews.vue?vue&type=style&index=0&id=dd7cac1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports